import React from "react";
import { Row, Col } from "react-bootstrap";
import Map from "../components/Map";
import Sidebar from "./Sidebar";
import "../styles/adminhome.css";

function AdminMap() {
    return (
        <div className="App">
            <Sidebar />

            <section className="tree-section">
                <br />
                <br />

                <Row>
                    <Col md={12}>
                        <div className="mapContainerAdminMap">
                            <Map />
                        </div>
                    </Col>
                </Row>
            </section>
        </div>
    );
}

export default AdminMap;